import React from "react"
import PropTypes from "prop-types"
// Styles
import { StyledForm, FormItem, StyledLabel, StyledInput, StyledTextArea, Wrapper, Title } from "./Address.styles"

const Address = ({ role, address, setAddress }) => {

    const handleChange = (e) => {
        e.preventDefault()
        setAddress((prev) => {
            return { ...prev, [e.target.name]: e.target.value }
        })
    }

    return (
        <Wrapper>
            <Title>{(role === "delivery") ? "Delivery Address" : "Invoice Address"}</Title>
            <StyledForm>
                <FormItem>
                    <StyledLabel>Name</StyledLabel>
                    <StyledInput type="text" name="name" defaultValue={address?.name} onChange={handleChange} />
                </FormItem>
                <FormItem>
                    <StyledLabel>Street</StyledLabel>
                    <StyledInput type="text" name="street" defaultValue={address?.street} onChange={handleChange} />
                </FormItem>
                <FormItem>
                    <StyledLabel>Zip Code</StyledLabel>
                    <StyledInput type="text" name="zipCode" defaultValue={address?.zipCode} onChange={handleChange} />
                </FormItem>
                <FormItem>
                    <StyledLabel>City</StyledLabel>
                    <StyledInput type="text" name="city" defaultValue={address?.city} onChange={handleChange} />
                </FormItem>
                <FormItem>
                    <StyledLabel>Region</StyledLabel>
                    <StyledInput type="text" name="region" defaultValue={address?.region} onChange={handleChange} />
                </FormItem>
                <FormItem>
                    <StyledLabel>Country</StyledLabel>
                    <StyledInput type="text" name="country" defaultValue={address?.country} onChange={handleChange} />
                </FormItem>
                <FormItem>
                    <StyledLabel>Info</StyledLabel>
                    <StyledTextArea name="info" defaultValue={address?.info} onChange={handleChange} />
                </FormItem>
            </StyledForm>
        </Wrapper>
    )
}

Address.propTypes = {
    role: PropTypes.string,
    address: PropTypes.object,
    setAddress: PropTypes.func
}

export default Address